import styled from 'styled-components';
import { withMargins } from '../../mixins/withMargins';
export const SkeletonWrapper = styled.div `
  animation-name: skeleton-loading;
  animation-duration: var(--transition-duration-5);
  animation-iteration-count: infinite;
  animation-timing-function: var(--transition-timing-ease);
  width: ${(props) => props.width};
  height: ${(props) => props.height};

  @keyframes skeleton-loading {
    0% {
      background: var(--skeleton-background-0);
    }
    20% {
      background: var(--skeleton-background-20);
    }
    40% {
      background: var(--skeleton-background-40);
    }
    60% {
      background: var(--skeleton-background-60);
    }
    80% {
      background: var(--skeleton-background-80);
    }
    100% {
      background: var(--skeleton-background-100);
    }
  }

  ${withMargins}
`;
